import { getStoredAccessToken, refreshSession } from "helpers/apiClient";
import { getDeviceHeaders } from "helpers/deviceInfo";

export class QgisRequestError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "QgisRequestError";
    this.status = status;
  }
}

const authenticationError = () =>
  new QgisRequestError("QGIS authentication failed", 401);

const requestError = (status) => {
  if (status === 401) return authenticationError();
  if (status === 403) {
    return new QgisRequestError("QGIS authorization failed", status);
  }
  return new QgisRequestError(`QGIS request failed with status ${status}`, status);
};

export const buildQgisAuthHeaders = (headers) => {
  const accessToken = getStoredAccessToken();
  if (!accessToken) throw authenticationError();

  const requestHeaders = new Headers(headers);
  requestHeaders.delete("X-Project-ID");
  requestHeaders.delete("X-QGIS-Project");
  Object.entries(getDeviceHeaders()).forEach(([name, value]) => {
    requestHeaders.set(name, value);
  });
  requestHeaders.set("Authorization", `Bearer ${accessToken}`);

  return requestHeaders;
};

const fetchWithCurrentSession = (url, options) => {
  const { headers, ...fetchOptions } = options;

  return fetch(url, {
    ...fetchOptions,
    // QGIS receives the bearer/device headers only. The HortaTech refresh
    // cookie remains scoped to the existing API refresh request.
    credentials: "omit",
    headers: buildQgisAuthHeaders(headers),
  });
};

export const fetchQgisResource = async (url, options = {}) => {
  let response = await fetchWithCurrentSession(url, options);

  if (response.status === 401) {
    try {
      await refreshSession();
    } catch (_) {
      throw authenticationError();
    }

    response = await fetchWithCurrentSession(url, options);
  }

  if (!response.ok) throw requestError(response.status);
  return response;
};
